import { createHistory } from 'history';
import { useRouterHistory } from 'react-router';
import { ROUTE_BASEPATH } from 'src/config/env/env.config';

export const browserHistory = useRouterHistory(createHistory)({
  basename: ROUTE_BASEPATH === '/' ? '' : ROUTE_BASEPATH,
});
